import { render } from "./InputDiagnosisDev.vue?vue&type=template&id=9e6f450a"
import script from "./InputDiagnosisDev.vue?vue&type=script&lang=js"
export * from "./InputDiagnosisDev.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__